import { cn } from '@/lib/utils'
import mark from '../assets/logo.png'
import bun from '../assets/logo-bun.png'

interface LogoProps {
  /**
   * `full` — bun tile + "BunCheck" wordmark.
   * `icon` — bun tile only (use on light surfaces; the tile gives the cream bun contrast).
   * `bun`  — transparent bun, no tile (use ONLY on dark/forest surfaces so it floats/blends).
   */
  variant?: 'full' | 'icon' | 'bun'
  className?: string
}

/**
 * BunCheck brand logo. Uses the approved bun mark PNG
 * (docs/brand/assets/png/buncheck-approved-logo-1024.png). The wordmark is
 * rendered as text. Do not recolor or redraw the mark.
 */
export function Logo({ variant = 'full', className }: LogoProps) {
  if (variant === 'bun') {
    return (
      <img
        src={bun}
        alt="BunCheck"
        className={cn('h-16 w-auto object-contain', className)}
      />
    )
  }

  if (variant === 'icon') {
    return (
      <img
        src={mark}
        alt="BunCheck"
        className={cn('h-8 w-8 rounded-[22%] object-cover', className)}
      />
    )
  }

  return (
    <span className={cn('inline-flex items-center gap-2.5 h-8', className)}>
      <img
        src={mark}
        alt=""
        aria-hidden="true"
        className="h-full w-auto aspect-square rounded-[22%] object-cover"
      />
      <span className="font-bold text-xl tracking-tight text-foreground">
        BunCheck
      </span>
    </span>
  )
}

export default Logo
